// Event handlers
import { ErrorHandlers } from '../handlers/error.handlers';
// Types
import { ErrorHandlersType } from '../handlers/types/error.handlers.type';

const useErrorHook = (): ErrorHandlersType => ErrorHandlers();

export { useErrorHook };
